module.exports = __webpack_public_path__ + "img/titlepage_las-vegas-market.4238ff2a.jpg";